import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Avatar } from "@opensea/next-ui-kit";
import { classNames } from "@opensea/ui-kit";
import { formatHexColor } from "@/lib/hex-color";
import { ItemAvatarFragment } from "./ItemAvatar.fragment";
export function ItemAvatar(t0) {
  const $ = _c(26);
  const {
    className,
    item,
    size,
    badge,
    style
  } = t0;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== badge || $[1] !== className || $[2] !== item || $[3] !== size) {
    const {
      imageUrl,
      tokenId,
      backgroundColor,
      collection
    } = readFragment(ItemAvatarFragment, item);
    T0 = Avatar;
    t2 = tokenId;
    t3 = badge;
    if ($[12] !== className) {
      t4 = classNames("shrink-0", className);
      $[12] = className;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    t5 = 1;
    t6 = size;
    t7 = imageUrl ?? collection?.imageUrl;
    t1 = formatHexColor(backgroundColor) || undefined;
    $[0] = badge;
    $[1] = className;
    $[2] = item;
    $[3] = size;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[14] !== style || $[15] !== t1) {
    t8 = {
      backgroundColor: t1,
      ...style
    };
    $[14] = style;
    $[15] = t1;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== T0 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <T0 alt={t2} badge={t3} className={t4} frameTime={t5} size={t6} src={t7} style={t8} />;
    $[17] = T0;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}